(() => {
  'use strict';
  const flT = globalThis.FellinoI18n.text;
  const energySource = 'https://www.aaha.org/wp-content/uploads/globalassets/05-pet-health-resources/nutritionalresources/hills-resources/hills-nutritional-reference-manual.pdf';
  const round = n => Math.max(1, Math.round(n / (n < 50 ? 1 : 5)) * (n < 50 ? 1 : 5));
  function interpolate(values, weight) {
    const rows = [...values].sort((a, b) => a[0] - b[0]);
    const exact = rows.find(r => Math.abs(r[0] - weight) < 1e-8);
    if (exact) return exact[1] ? { range: exact[1], between: false } : null;
    for (let i = 1; i < rows.length; i++) {
      const a = rows[i - 1], b = rows[i];
      if (a[0] < weight && weight < b[0]) {
        if (!a[1] || !b[1]) return null;
        const share = (weight - a[0]) / (b[0] - a[0]);
        return { range: a[1].map((v, j) => v + (b[1][j] - v) * share), between: true };
      }
    }
    return null;
  }
  function portion(food, p) {
    if (p.health !== 'healthy' || !Number.isFinite(p.weight) || p.weight <= 0 || p.months < 2 || !food.feeding) return null;
    const data = food.feeding;
    let reference, label, between = false, mode = 'table', source = data.source;
    if (data.kind === 'perKg') {
      reference = (p.weight <= data.threshold ? data.small : data.large).map(g => g * p.weight);
      label = flT("s7c6cef2d4de6",[ p.weight <= data.threshold ? flT("s34093dde306c",[ data.threshold ]) : flT("s636ee50fc02f",[ data.threshold ]) ]);
    } else if (data.kind === 'table') {
      const column = p.stage === 'puppy'
        ? data.columns.find(c => c.age && c.age[0] <= p.months && p.months < c.age[1])
        : data.columns.find(c => c.activity === p.activity) || data.columns.find(c => c.activity === 'range');
      if (!column) {
        // No invented activity multiplier on top of a manufacturer's table.
        // When that activity is absent, use a clearly separate energy estimate.
        if (p.stage === 'puppy' || !food.kcal100) return null;
        const coverage = data.columns.find(c => c.activity === flT("s317b32c14369"));
        if (!coverage || !interpolate(coverage.values, p.weight)) return null;
        const factor = p.activity === 'high' ? 2 : p.activity === 'low' ? 1.4 : p.neutered === 'yes' ? 1.6 : 1.8;
        const kcal = 70 * Math.pow(p.weight, 0.75) * factor;
        const daily = round(kcal * 100 / food.kcal100);
        return { daily, low: daily, high: daily, mode: 'energy', between: false, label: flT("sbc870bc84ff3",[ p.weight.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE')), factor.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE')) ]), source: energySource, caution: flT("s0cf724b178ca") };
      }
      const value = interpolate(column.values, p.stage === 'puppy' ? p.size : p.weight);
      if (!value) return null;
      reference = value.range; between = value.between; label = globalThis.FellinoI18n.source(column.label);
    } else return null;
    const [low, high] = reference;
    const selected = p.stage === 'puppy' ? (low + high) / 2 : p.activity === 'low' ? low : p.activity === 'high' ? high : (low + high) / 2;
    return { daily: round(selected), low: round(low), high: round(high), between, mode, source, label, caution: low === high ? '' : flT("s7140bdf6cef5") };
  }
  function meals(grams, count) {
    return Array.from({ length: count }, (_, i) => Math.floor(grams / count) + (i < grams % count ? 1 : 0));
  }
  function plan(food, p, options = {}) {
    const base = portion(food, p);
    if (!base) return { error: flT("s92e345fcc786") };
    const count = Number(options.meals || (p.stage === 'puppy' ? 3 : 2));
    const snack = Number(options.snack || 0), wetPercent = Number(options.wetPercent ?? 50);
    const minimumMeals = p.stage === 'puppy' && p.months < 6 ? 3 : 2;
    if (!Number.isInteger(count) || count < minimumMeals || count > 4 || ![0, 5, 10].includes(snack)) return { error: flT("s610e47ba96fc") };
    const kcal = food.kcal100 ? base.daily * food.kcal100 / 100 : null;
    let amounts;
    if (options.other) {
      const other = options.other;
      if (!food.kcal100 || !other.kcal100 || food.form === other.form || !portion(other, p) || ![25, 50, 75].includes(wetPercent)) return { error: flT("sfd784c105437") };
      amounts = [food, other].map(f => {
        const share = f.form === 'wet' ? wetPercent / 100 : 1 - wetPercent / 100;
        return { food: f, grams: Math.max(1, Math.round(kcal * (1 - snack / 100) * share * 100 / f.kcal100)) };
      });
    } else amounts = [{ food, grams: Math.max(1, Math.round(base.daily * (1 - snack / 100))) }];
    amounts.forEach(x => { x.meals = meals(x.grams, count); x.weeklyKg = x.grams * 7 / 1000; });
    return { base, count, snack, totalKcal: kcal, snackKcal: kcal === null ? null : kcal * snack / 100, amounts, wetPercent };
  }
  // Stateless calculation helpers. Dog profiles remain inside the page component.
  window.FellinoFeeding = Object.freeze({ portion, plan, interpolate });
})();
